import rules from '@/validation/rules.js'

export default {

  data() {
    return {
      rules: rules
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/MixinValidator.js